import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
import { MediaTypes } from '../../commands/practitioner/enums/MediaTypes';

export interface UploadContext {
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  isUploadTabOpen: boolean;
  setIsUploadTabIsOpen: Dispatch<SetStateAction<boolean>>;
  uploadedFileName: string;
  setUploadedFileName: Dispatch<SetStateAction<string>>;
  isExpiredTime: boolean;
  setIsExpiredTime: Dispatch<SetStateAction<boolean>>;
  audioTypeFilename: string;
  setAudioTypeFilename: Dispatch<SetStateAction<string>>;
  practitionerMediaTypeUpload: number;
  setPractitionerMediaTypeUpload: Dispatch<SetStateAction<number>>;
  progress: number;
  setProgress: Dispatch<SetStateAction<number>>;
  uploadRequest: React.MutableRefObject<XMLHttpRequest | null>;
  fileInput: File[];
  setFileInput: Dispatch<SetStateAction<File[]>>;
}

export const UploadContext = createContext<UploadContext>(null!);

interface UploadProviderProps {
  children: any;
}

const UploadProvider: React.FC<UploadProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isUploadTabOpen, setIsUploadTabIsOpen] = useState<boolean>(false);
  const [uploadedFileName, setUploadedFileName] = useState<string>('');
  const [isExpiredTime, setIsExpiredTime] = useState<boolean>(false);
  const [audioTypeFilename, setAudioTypeFilename] = useState<string>('');
  const [practitionerMediaTypeUpload, setPractitionerMediaTypeUpload] = useState<MediaTypes>(MediaTypes.VIDEO);
  const [progress, setProgress] = React.useState<number>(0);
  const uploadRequest = React.useRef<XMLHttpRequest | null>(null);
  const [fileInput, setFileInput] = useState<File[]>([]);

  return (
    <UploadContext.Provider
      value={{
        isLoading,
        setIsLoading,
        isUploadTabOpen,
        setIsUploadTabIsOpen,
        uploadedFileName,
        setUploadedFileName,
        isExpiredTime,
        setIsExpiredTime,
        audioTypeFilename,
        setAudioTypeFilename,
        setPractitionerMediaTypeUpload,
        practitionerMediaTypeUpload,
        progress,
        setProgress,
        uploadRequest,
        fileInput,
        setFileInput,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};

export default UploadProvider;
